import {Box, Typography} from '@mui/material';
import {Quiz} from '@mui/icons-material';

interface QuestionReviewHeaderProps {
  totalQuestions: number;
}

export default function QuestionReviewHeader({totalQuestions}: QuestionReviewHeaderProps) {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 3}}>
      <Quiz sx={{color: 'primary.main'}} />
      <Typography variant="h6" sx={{fontWeight: 600}}>
        Review All Questions ({totalQuestions})
      </Typography>
    </Box>
  );
}
